import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { DespatchAdvice } from '../../data/models'
import i18n from '../../utils/i18n'

export const DeliveryTypeFilterTemplate = (options: any) => {
  if (!options) return null

  const deliveryTypes: DespatchAdvice['DeliveryType'][] = ['FULL', 'PARTLY']

  const valueTemplate = (
    option: DespatchAdvice['DeliveryType'],
    props: any,
  ) => {
    if (option) {
      return (
        <>
          {option === 'FULL'
            ? i18n.t('common.codes.deliveryType.full')
            : i18n.t('common.codes.deliveryType.partly')}
        </>
      )
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: DespatchAdvice['DeliveryType']) => {
    return (
      <>
        {option === 'FULL'
          ? i18n.t('common.codes.deliveryType.full')
          : i18n.t('common.codes.deliveryType.partly')}
      </>
    )
  }

  return (
    <Dropdown
      value={options.value}
      options={deliveryTypes}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchDeliveryType')}
    />
  )
}
